import { useEffect, useState } from 'react'
import './VUMeter.css'

interface VUMeterProps {
  label: string
  peakDb: number
  enabled: boolean
  orientation?: 'horizontal' | 'vertical'
}

export function VUMeter({ label, peakDb, enabled, orientation = 'horizontal' }: VUMeterProps) {
  const [displayPeakDb, setDisplayPeakDb] = useState(-96)

  useEffect(() => {
    if (!enabled) {
      setDisplayPeakDb(-96)
      return
    }
    setDisplayPeakDb(peakDb)
  }, [peakDb, enabled])

  // Map peakDb from [-60, 0] dBFS to 0-100%
  const percent = Math.max(0, Math.min(100, ((displayPeakDb + 60) / 60) * 100))

  // Color coding: green (safe), yellow (warning > -12dB), red (clipping > -3dB)
  const backgroundColor =
    displayPeakDb > -3 ? '#ff4444' :
    displayPeakDb > -12 ? '#ffaa00' :
    '#44ff44'

  const isVertical = orientation === 'vertical'

  return (
    <div className={`vu-meter ${isVertical ? 'vu-meter--vertical' : ''}`}>
      <div className="vu-meter__label">{label}</div>
      <div className={`level-meter ${isVertical ? 'level-meter--vertical' : ''}`}>
        <div
          className={`level-meter-fill ${isVertical ? 'level-meter-fill--vertical' : ''}`}
          style={
            isVertical
              ? { height: `${percent}%`, backgroundColor }
              : { width: `${percent}%`, backgroundColor }
          }
        />
        <div className={`level-meter-ticks ${isVertical ? 'level-meter-ticks--vertical' : ''}`}>
          <span>-60</span>
          <span>-48</span>
          <span>-36</span>
          <span>-24</span>
          <span>-12</span>
          <span>-6</span>
          <span>0</span>
        </div>
      </div>
    </div>
  )
}
